// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-355c703d]{font-size:30px;padding:5px;color:#4abca5;text-align:center}.title-box[data-v-355c703d]{margin:50px 25px 0 25px}.content-box[data-v-355c703d]{margin:60px 25px 0 25px}.bottom-bar[data-v-355c703d]{background-color:#4abca5;border-top-style:solid;border-top-color:#837d89;border-top-width:5px}", ""]);
// Exports
module.exports = exports;
